import { render, staticRenderFns } from "./offlineavespin.vue?vue&type=template&id=07c6166e&scoped=true&"
import script from "./offlineavespin.vue?vue&type=script&lang=js&"
export * from "./offlineavespin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6166e",
  null
  
)

export default component.exports